export default __webpack_public_path__ + "static/media/Wolf's Vambraces of the Khan.e3f50332.jpg";